import React from 'react';
import { Box, Typography, Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

// A card section title with an optional hover explanation.
export default function SectionHeader({ title, tooltip }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 1.5 }}>
      <Typography variant="subtitle2" fontWeight={600}>{title}</Typography>
      {tooltip && (
        <Tooltip title={tooltip} placement="right">
          {/* Focusable, so the explanation is reachable by keyboard and screen reader, not only by hover. */}
          <Box component="span" tabIndex={0} role="img" sx={{ display: 'inline-flex', cursor: 'help' }}>
            <InfoOutlinedIcon sx={{ fontSize: 15, color: 'text.disabled' }} />
          </Box>
        </Tooltip>
      )}
    </Box>
  );
}
